'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Switch = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('@material-ui/core/styles');

var _core = require('@material-ui/core');

var _form = require('../../schema/component/form.json');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */


var schema = _form.properties.switch.properties;

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    switch: {
      margin: '-9px',
      '& .Mui-checked': {
        color: function color(_ref) {
          var _color = _ref.color;
          return _color;
        }
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: function backgroundColor(_ref2) {
          var color = _ref2.color;
          return color;
        },
        opacity: '0.38'
      }
    }
  };
});

var Switch = function Switch(_ref3) {
  var color = _ref3.color,
      props = _objectWithoutProperties(_ref3, ['color']);

  var variantDefault = schema.default.properties;
  var classes = useStyles(_extends({}, variantDefault, {
    color: color || variantDefault && variantDefault.color
  }));

  return _react2.default.createElement(_core.Switch, _extends({ className: classes.switch }, props));
};

exports.Switch = Switch;
Switch.defaultProps = {
  color: null
};

Switch.propTypes = {
  color: _propTypes2.default.string
};

exports.default = Switch;